import React from "react";

interface StandaloneLegendProps {
    getColor: (value: number, dataset: string) => string;
    minValue?: number;
    maxValue?: number;
    polygon_type: "Continuous" | "Discrete";
    bins?: number;
    polygon_values: { [key: string]: string };
    current_dataset: string;
    attribute_legend_labels: string;
    categories: { [key: string]: number; };
}

const StandaloneLegend: React.FC<StandaloneLegendProps> = ({
    getColor,
    minValue = 0,
    maxValue = 1,
    polygon_type = "Discrete",
    bins = 0,
    polygon_values,
    current_dataset,
    attribute_legend_labels,
    categories
}) => {
    // Simplified legend to match Image 1
    return (
        <div style={{
            textAlign: 'center'
        }}>
            <h3 style={{ 
              margin: '0 0 15px 0', 
              fontSize: '16px', 
              fontWeight: '600',
              color: '#4a5568'
            }}>Legend</h3>
            
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '20px'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <div style={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: '#006400', //#8B0000
                        marginRight: '8px',
                        border: '1px solid #e0e0e0'
                    }}></div>
                    <span>High</span>
                </div>
                
                <div style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <div style={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: '#FFFFE0',
                        marginRight: '8px',
                        border: '1px solid #e0e0e0'
                    }}></div>
                    <span>Medium</span>
                </div>
                
                <div style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <div style={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: '#8B0000', // #006400
                        marginRight: '8px',
                        border: '1px solid #e0e0e0'
                    }}></div>
                    <span>Low</span>
                </div>
            </div>
        </div>
    );
};

export default StandaloneLegend;